import { default as slugifyCore } from '@core/utils/url/slugify';
import i18n from '@app/localization/i18n';

export function slugify(text: string, options = { translate: true }): string {
    if (options.translate) {
        return slugifyCore(i18n.t(text).toString());
    }
    return slugifyCore(text);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/utils/slugify.ts